<template>
  <div class="protocol">
    Last revised on August 6, 2026
    <br /><br />

    <div class="bt" style="text-align: center">
      {{ appName }}'s Child Safety Standards
    </div>
    <br/>

    <div class="bt">1. Child Safety Commitment</div>
    <div>
      {{ appName }} prioritizes the protection of minors and adopts a zero-tolerance
      policy for all Child Sexual Abuse and Exploitation (CSAE). This standard
      governs all chats, published content and user interactions on our platform.
      <br /><br />
    </div>
    <div class="bt subtitle">Prohibited Behaviors</div>
    <div>
      Creating, uploading or distributing Child Sexual Abuse Material (CSAM) and
      AI-generated pornographic content involving minors
      <br /><br />
      Grooming, harassing or coercing minors to share off-platform contact
      information or private intimate media
      <br /><br />
      Sexual extortion and arranging in-person meetings with minors for
      exploitative purposes
      <br /><br />
      Disclosing minors’ private information, stalking or threatening minor users
      <br /><br />
      Instigating or assisting other users to commit any of the above violations
      <br /><br />
    </div>

    <div class="bt">2. Age Control Rules (Mandated by Google)</div>
    <div>
      The minimum registration age is 18; users under 18 are classified as
      minors.
      <br /><br />
      Users must submit accurate birth dates during registration. {{ appName }} reserves
      the right to request identity verification when necessary.
      <br /><br />
      Minors are restricted from high-risk features including random stranger
      matching and anonymous one-on-one private chat.
      <br /><br />
    </div>

    <div class="bt">3. Platform Safety Protection Mechanisms</div>
    <div>
      Real-time AI scanning for all images, videos and messages, supported by
      24/7 manual moderation to block grooming language and sexualized content.
      <br /><br />
      Confirmed violating content will be permanently deleted. We conduct unified
      risk control over all linked accounts, devices and IP addresses of
      violators.
      <br /><br />
      All evidence related to CSAE violations will be encrypted and securely
      stored to cooperate with designated global child protection authorities.
      <br /><br />
    </div>

    <div class="bt">4. Reporting Channels</div>
    <div>
      Primary Channel: Built-in report button inside every chat window and user
      profile. Select the dedicated CSAE category to escalate reports quickly.
      <br /><br />
      Backup Email for Child Safety Reports:
      <span class="email">{{ appEmail }}</span>
      <br /><br />
      Required email subject format: URGENT CSAE REPORT + Violator User ID
      <br /><br />
      All CSAE reports will be reviewed within 24 hours. Reporters’ identities
      will be kept strictly confidential at all times.
      <br /><br />
    </div>

    <div class="bt">5. Penalties for Violations</div>
    <div>
      Upon receiving a CSAE report or automated risk alert, the violating account
      will be immediately restricted from sending messages and matching other
      users pending investigation.
      <br /><br />
      Once a CSAE violation is verified, the account will be permanently banned.
      Banned users cannot register new accounts with the same phone number or
      device.
      <br /><br />
      Severe CSAM and child exploitation cases will be mandatorily reported to
      global official child protection agencies with complete supporting evidence
      submitted as required by law.
      <br /><br />
    </div>

    <div class="bt">6. Appeal Process for Wrongful Penalties</div>
    <div>
      If your account is penalized by mistake due to false CSAE detection, you may
      submit an appeal via the above dedicated email.
      <br /><br />
      Required email subject format: CSAE WRONGFUL BAN APPEAL + Your User ID
      <br /><br />
      Independent senior safety staff will review your appeal separately. All
      account restrictions will be lifted immediately if the false detection is
      confirmed.
      <br /><br />
    </div>

    <div class="bt">7. Policy Disclosure Statement</div>
    <div>
      This standard is permanently published on the platform’s Terms of Service
      page. We will update this document promptly to align with the latest Google
      Play safety policies.
      <br /><br />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
};
</script>

<style scoped>
.table-container {
  width: 100%;
  overflow-x: auto;
}
table {
  border-collapse: collapse;
  max-width: 100%;
  width: 100%;
  margin: 0.2267rem 0;
  font-family: Arial, sans-serif;
}
td {
  padding: 0.2267rem;
  border: 1px solid #ddd;
  word-wrap: break-word;
  white-space: normal;
}

.protocol {
  width: 100%;
  font-size: 0.9rem;
  margin-bottom: 0.4667rem;
  color: #666;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  box-sizing: border-box;
}
.bt {
  font-size: 1.3rem;
  margin: 0.2rem 0px;
  color: #000;
}
.subtitle {
  font-size: 1.1rem;
  color: #333;
}
.email {
  color: #409eff;
  font-weight: 600;
  word-break: break-all;
}
</style>
